import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-display-message-modal',
  templateUrl: './display-message-modal.component.html',
  styleUrls: ['./display-message-modal.component.scss']
})
export class DisplayMessageModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  @Input() headerMsg: string = "Please Wait!";
  @Input() bodyMsg1: string = "Please wait....";
  @Input() bodyMsg2: string;

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/display-message-modal/display-message-modal.component.ts